import { Component, OnInit, ViewChild, ElementRef, Input, OnChanges, Output, EventEmitter, HostListener, OnDestroy } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { AnnotationService } from '../../service/annotation.service';
import { Subscription } from 'rxjs';
import { flatten, unflatten } from 'lodash/array';
import { FormControl } from '@angular/forms';
import 'parse';
import { SSL_OP_SINGLE_DH_USE } from 'constants';
import { SearchTagCheckbox } from '../../model/search';
import { Router } from '@angular/router';
import { SearchService } from '../../service/search.service';
import { Tchekb, TchekImages } from '../../model/tchekb.model';
import { ToastService } from '../../service/toast.service';
import { ReportService } from '../../service/report.service';
const parse: typeof Parse = require('parse');
import { Subject } from 'rxjs';
import { Damage, DamageAnalysis, RoiAnalysis, classificationStatusRoi } from '../../model/damage.model';
import { ClassificationService } from '../../service/classification.service';
import { VehicleDamagePipe } from '../../pipes/vehicle-damage.pipe';
import { DamageService } from '../../service/damage.service';
import { RoiService } from '../../service/roi.service';
import { Location } from '@angular/common';
import { TchekImage } from '../../model/image';
import { ImagesService } from '../../service/images.service';
import { iaTag } from '../../model/iaTag.model';
import { ImageClassification } from '../../model/imageClassification.model';
import { I18n } from '@ngx-translate/i18n-polyfill';

declare const $: any;



@Component({
  selector: 'app-annotation-drawer',
  templateUrl: './annotation-drawer.component.html',
  styleUrls: ['./annotation-drawer.component.less'],
  animations: [
    trigger('openClose', [
      state('open', style({
        right: '0px'
      })),
      state('closed', style({
        right: '-28vw'
      })),
      transition('open => closed', [
        animate('350ms ease-out')
      ]),
      transition('closed => open', [
        animate('350ms ease-out')
      ]),
    ]),
  ]
})

export class AnnotationDrawerComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('drawerContent') drawerContent: ElementRef;
  @Input() tchekId: string;
  @Input() tchek: TchekImages;
  @Input() cameraName: string;
  @Input() isSliding: boolean;
  @Input() pictureNumber: string;
  @Input() currentImage: TchekImage;
  @Input() isAnnotated: boolean;
  @Input() forValidation: boolean;
  @Output() onAnnotated: EventEmitter<any> = new EventEmitter<any>();
  @Output() onValidation: EventEmitter<any> = new EventEmitter<any>();
  classificationStatusRoi = classificationStatusRoi;
  saveTimers: Array<NodeJS.Timer>;
  isOpen: boolean;
  autoRois: any;
  autoRoisSearch: any;
  listDamagesOptions = []
  isSuperAdmin = false;
  subscription: Subscription[];
  listDamagesDefault = []// AnnotationService._damageTypes;
  annotationsTopBarIsOpen: boolean = false;
  imageActiveDamages: any[] = []
  imageActiveParts: any[] = []
  annotationSelectedDamage: string;
  selectStyleGuide = {
    caretClass: 'caret',
    selectBoxClass: 'dropdown-wrapper dropdown-current-bold',
    selectMenuClass: 'dropdown',
    optionsClass: 'option'
  };
  options = [];
  listDamagesAttributes = {};
  listPartsAttributes = {};
  listDamages = [];// AnnotationService._damageTypes;
  listPieces = [];//AnnotationService._partTypes;
  listAnnotateOnAttributes = [];
  classificationSelectedRoi: RoiAnalysis
  selectedRoi: { count: number, type: string, attributes: {}[], id: string };
  damageList: DamageAnalysis[];
  damageSelected: DamageAnalysis;
  damageSelectedFc: any[] = [];
  selectedRoiFc: string[] = [];
  activeAnnotationType: SearchTagCheckbox[] = [];
  cpt: number = -1;
  listTchek: Array<Tchekb> = [];
  next: string = this.i18n({
    id: 'next',
    value: "suivant",
    description: "suivant",
    meaning: "annotation"
  });
  previous: string = this.i18n({
    id: 'previous',
    value: "Tchek Précédent",
    description: "Tchek Précédent",
    meaning: "annotation"
  });
  hideTypeList: SearchTagCheckbox[];
  classificationIsActive: boolean = false;
  hideDamages: boolean = false;
  typeExist: boolean = false;
  DEBUG: boolean = false;

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (!this.isSuperAdmin)
      return

    if (this.classificationIsActive) {
      if (event.key === '.')
        this.fp()
      if (event.key === '0')
        this.saveClassification(undefined, this.classificationStatusRoi.classified, event.key)
      if (event.key === '1')
        this.saveClassification(undefined, this.classificationStatusRoi.classified, event.key)
      if (event.key === '2')
        this.saveClassification(undefined, this.classificationStatusRoi.classified, event.key)
      if (event.key === '3')
        this.saveClassification(undefined, this.classificationStatusRoi.classified, event.key)
      if (event.key === '4')
        this.saveClassification(undefined, this.classificationStatusRoi.classified, event.key)
      if (event.key === '5')
        this.saveClassification(undefined, this.classificationStatusRoi.classified, event.key)
    } else {
      if (event.keyCode === 65) {
        if (this.hideTypeList && this.hideTypeList[1])
          this.hideTypeList[1].checked = !this.hideTypeList[1].checked;
        this.editHideTypeList(this.hideTypeList)
      }
      if (event.keyCode === 67) {
        if (!this.imageActiveDamages.includes('Capteur')) {
          this.imageActiveDamages.push('Capteur')
          this.saveImageActive()
        }
      }
      if (event.keyCode === 71) {
        if (!this.imageActiveDamages.includes('Gicleur')) {
          this.imageActiveDamages.push('Gicleur')
          this.saveImageActive()
        }
      }

      let code = event.keyCode - 48
      if (code >= 0 && code < 10) {
        //  console.log("KEY_CODE", code)
        let tab = flatten(Object.entries(this.listDamagesAttributes["Bosse"]));
        this.selectedRoi.type = "Bosse"
        this.selectedRoi.attributes = [{ name: tab[0], value: tab[1][code] }]

        this.autoRoisSearch[this.selectedRoi.count - 1].set('label', this.selectedRoi.type)
        this.autoRoisSearch[this.selectedRoi.count - 1].set('attributes', this.selectedRoi.attributes)
        this.autoRoisSearch[this.selectedRoi.count - 1].save().then((res) => {
          this.arrowMoveAnnotation(1)
          this._toastService.toastOpen(undefined,
            this.i18n({
              id: 'update',
              value: "Mis à jour",
              description: "Mis à jour",
              meaning: "annotation"
            }))
          this.updateActiveAnnotationType();
        })
      }
    }
  }

  redirectToAnnotation(a) {
    if (a.get('imagePtr')) {
      this._router.navigate(['/viewer', this.tchekId, a.get('imagePtr').id]);
    } else
      this._router.navigate(['/player', this.tchekId,
        a.get('folder'), this.toPicturePercent(a.get('sequence'), a.folderPtr.get('totalPictures'))]);

  }


  hideDamagesClassification() {
    this.hideDamages = !this.hideDamages
    this._classificationService.setHideDamages(this.hideDamages)
  }

  ngOnDestroy() {
    // prevent memory leak when component destroyed
    this.subscription.forEach(subscription => {
      subscription.unsubscribe();
    });
  }

  changeSelectedRoi(event, type?: boolean, unsave?: boolean) {
    this._annotationService.getImageActive()
    if (type) {
      if (event !== this.selectedRoi.type) {
        this.selectedRoi.type = event;
        this.selectedRoi.attributes = []
      }
      let i = 0;
      this.listAnnotateOnAttributes = [];
      let listAttribute;
      if (this.getAnnotateType(this.selectedRoi.type) === 'part')
        listAttribute = this.listPartsAttributes;
      else
        listAttribute = this.listDamagesAttributes;
      if (listAttribute[event]) {
        let tab = flatten(Object.entries(listAttribute[event]));
        while (tab[i]) {
          let value: { key: string, value: string, attributes: string }[] = [];
          tab[i + 1].forEach(element => {
            value.push({ key: element, value: element, attributes: tab[i] });
          });

          this.listAnnotateOnAttributes.push({ name: tab[i], list: value, count: i + 1 });
          let save = 0;

          if (this.selectedRoi.attributes && this.selectedRoi.attributes[0]) {
            this.selectedRoi.attributes.forEach((e: { name: string, value: string }) => {
              if (e.value === 'empty' && e.name === tab[i])
                this.selectedRoiFc[i + 1] = 'empty'
              else if (e.name === tab[i] && event === this.selectedRoi.type)
                if (e.value) {
                  this.selectedRoiFc[i + 1] = e.value
                  save++;
                }
              if (save === 0)
                this.selectedRoiFc[i + 1] = 'empty'
            });
          }
          else
            this.selectedRoiFc[i + 1] = 'empty'

          i += 2;
        }
      }
    }
    if (event.attributes && event.key) {
      let saver = 0;
      if (this.selectedRoi.attributes) {
        this.selectedRoi.attributes.forEach((e: { name: string, value: string }) => {
          if (e.name === event.attributes) {
            saver = 1;
            e.value = event.key;
          }
        });
      } else {
        this.selectedRoi.attributes = [];
      }
      if (saver === 0)
        this.selectedRoi.attributes.push({ name: event.attributes, value: event.key })
    }
    //  console.log("list", this.listDamages, this.listPieces, this.listAnnotateOnAttributes)

    if (!unsave)
      this.saveUpdateAnnotation()
  }

  saveUpdateAnnotation() {
    if (this.saveTimers[this.selectedRoi.id]) {
      clearTimeout(this.saveTimers[this.selectedRoi.id]);
      this.saveTimers[this.selectedRoi.id] = undefined;
    }
    this.saveTimers[this.selectedRoi.id] = setTimeout(() => {
      this.autoRoisSearch[this.selectedRoi.count - 1].set('label', this.selectedRoi.type)
      this.autoRoisSearch[this.selectedRoi.count - 1].set('attributes', this.selectedRoi.attributes)
      this.autoRoisSearch[this.selectedRoi.count - 1].save().then((res) => {
        // console.log("saved", res);
        this._toastService.toastOpen(undefined,
          this.i18n({
            id: 'update',
            value: "Mis à jour",
            description: "Mis à jour",
            meaning: "annotation"
          }))
        this.updateActiveAnnotationType();
      })
      this.saveTimers[this.selectedRoi.id] = undefined;
    }, 500);
  }


  saveImageActive() {
    if (this.saveTimers['ImageActive']) {
      clearTimeout(this.saveTimers['ImageActive']);
      this.saveTimers['ImageActive'] = undefined;
    }
    this.saveTimers['ImageActive'] = setTimeout(() => {
      this._annotationService.saveImageActive([this.imageActiveDamages, this.imageActiveParts]);
      this.saveTimers['ImageActive'] = undefined;
    }, 1000);
  }


  openAnnotationTopBar() {
    this.annotationsTopBarIsOpen = !this.annotationsTopBarIsOpen
    if (!this.annotationsTopBarIsOpen) {
      $("#annotations-select-active-pieces").css({ display: 'none' })
      $("#annotations-select-active-damages").css({ display: 'none' })
    }
  }

  showAnnotationSelectActive(name: String) {
    let btnAnnotationActiveDamages = $("#btnAnnotationActiveDamages").position()
    let btnAnnotationActivePieces = $("#btnAnnotationActivePieces").position()

    if (name === 'pieces') {
      $("#annotations-select-active-pieces").toggle({ display: 'block' })
    }

    if (name === 'damages') {
      $("#annotations-select-active-damages").toggle({ display: 'block' })
    }

    $("#annotations-select-active-damages").css({ top: 70, left: btnAnnotationActiveDamages.left + 20, position: 'fixed' });
    $("#annotations-select-active-pieces").css({ top: 70, left: btnAnnotationActivePieces.left + 20, position: 'fixed' });
  }

  handleDamageToggleCheckbox2(event) {
    if (this.imageActiveDamages === undefined)
      this.imageActiveDamages = [];

    if (this.imageActiveDamages.length == 0) {

    }
    if (event.srcElement.checked) {
      this.imageActiveDamages = this.listDamagesDefault;
    } else {
      this.imageActiveDamages = [];
    }
    this.saveImageActive()
  }

  handleDamageToggleCheckbox(event: Event, damage: String) {
    // Protect against undefined value
    if (this.imageActiveDamages === undefined)
      this.imageActiveDamages = [];
    if (this.imageActiveParts === undefined)
      this.imageActiveParts = [];

    if (this.imageActiveDamages.includes(damage)) {
      const index = this.imageActiveDamages.indexOf(damage);
      this.imageActiveDamages.splice(index, 1);
    } else {
      this.imageActiveDamages.push(damage)
    }
    this._classificationService.canSave = false
    this.saveImageActive()
  }

  handlePartsToggleCheckbox(event: Event, part: String) {
    // Protect against undefined value
    if (this.imageActiveParts === undefined)
      this.imageActiveParts = [];

    if (this.imageActiveParts.includes(part)) {
      const index = this.imageActiveParts.indexOf(part);
      this.imageActiveParts.splice(index, 1);
    } else {
      this.imageActiveParts.push(part)
    }
    this.saveImageActive()
  }


  isDamageSelected(damage: String): boolean {
    if (!this.imageActiveDamages)
      return false;
    return this.imageActiveDamages.includes(damage);
  }

  isPartSelected(part: String): boolean {
    if (!this.imageActiveParts)
      return false;
    return this.imageActiveParts.includes(part);
  }

  editHideTypeList(list) {
    this._annotationService.setHideList(list)
  }


  constructor(private _annotationService: AnnotationService,
    private readonly i18n: I18n,
    private readonly _roiService: RoiService,
    private readonly _damageService: DamageService,
    private readonly _vehicledamage: VehicleDamagePipe,
    private readonly _toastService: ToastService,
    private readonly _imagesService: ImagesService,
    private readonly _router: Router,
    private _location: Location,
    private readonly _searchService: SearchService,
    public readonly _classificationService: ClassificationService) {
    this.subscription = [];
    this.isSuperAdmin = parse.User.current().get('isSuperAdmin');
    this.isOpen = false;
    this.listTchek = _searchService.TchekList;
    this.listPieces = _annotationService._partTypes;
    this.listDamages = _annotationService._damageTypes;
    this.listDamagesOptions = _annotationService._damageTypesOptions;
    this.listDamagesDefault = _annotationService._damageDefaultTypes;
    this.listDamagesAttributes = _annotationService._damageAtributes;
    this.listPartsAttributes = _annotationService._partAtributes;
    this.saveTimers = [];
    this.hideTypeList = _annotationService.getHideList();
    this.classificationIsActive = this._classificationService.active;
    this.subscription[0] = this._annotationService.activeImageObs.subscribe(data => {
      if (!data) {
        this.imageActiveParts = [];
        this.imageActiveDamages = [];
      }
      else if (data.length === 2) {
        if (data[0])
          this.imageActiveDamages = data[0];
        else
          this.imageActiveDamages = [];
        if (data[1])
          this.imageActiveParts = data[1];
        else
          this.imageActiveParts = [];
      } else {
        this.imageActiveParts = [];
        this.imageActiveDamages = data;
      }
    });


    if (this.classificationIsActive) {
      this.damageList = this._classificationService.getDamageList();
      this.damageSelected = this._classificationService.getSelectedDamage();

      this.subscription[1] = this._classificationService.listDamageObs
        .subscribe(damageList => {
          this.damageList = damageList;
          if (this.damageList.length > 0) {
            this.setSelectDamage(this.damageList[0].id);
          } else {
            this.damageSelected = undefined;
            // pass to nest tchek
            this.arrowMoveClassification(1)
          }
        })

      this.subscription[2] = this._classificationService.selectedDamageObs
        .subscribe(damageSelected => {
          console.log('damage annotation drawer');
          this.damageSelected = damageSelected;
          this.setSelectDamage(damageSelected.id)
        })

      this.subscription[3] = this._classificationService.selectedRoiObs
        .subscribe(roiSelected => {
          this.classificationSelectedRoi = roiSelected;
        })

    }
  }

  ngOnInit() {
    this._annotationService.newAnnotation.subscribe(data => {
      this.loadAnnotations()
    })
  }


  ngOnChanges(changes) {
    if ((changes.tchekId && changes.tchekId.currentValue !== undefined)) {
      // console.log('changes ', changes, ' getting with ', this.tchekId, this.cameraName);
      this.loadAnnotations()
    }

    if (changes.isSliding && changes.isSliding.currentValue !== undefined && !changes.isSliding.firstChange) {
      this.searchAnnotationType()
    }
  }

  loadAnnotations() {
    this._annotationService.getAnnotation(this.tchekId).then(rois => {
      // console.log("getAnnotation", rois)
      this.autoRois = rois.sort((a, b) => {
        if (a.get('label') > b.get('label')) {
          return 1;
        }
        if (b.get('label') > a.get('label')) {
          return -1;
        }
        return 0;
      }
      )//this._annotationService.groupAnnotationsByCamera(rois);
      this.updateActiveAnnotationType();
      this.searchAnnotationType();
    }, error => console.error('Could not get auto ROIs ', error));
  }


  open() {
    this.isOpen = true;
  }

  close() {
    this.isOpen = false;
  }

  toPicturePercent(numberPicture: number, totalPictures?: number): string {
    /* console.log('cam name ', this.cameraNumber, ' list ', this.listAnimation.array,
    ' this camera ', this.listAnimation.get(this.cameraNumber)); */
    if (totalPictures === undefined)
      console.warn('Both argument totalPictures and listCamera.totalPictures are undefined');
    /* console.log('numPic ', numberPicture, ' totalPic ', totalPictures, 'calcPercent ',
    ((numberPicture / totalPictures) * 100)); */
    return (Math.ceil((numberPicture / totalPictures) * 100)).toString();
    // Minus 1 to fix last image being blank
  }




  handleListItemClick(event: any, id?: string) {
    //    console.log("click event", event.target);
    $('.list-group-item').removeClass('active');
    // Setting bcg color
    $(event.target)
      .parentsUntil('div.content')
      .filter('.list-group-item')
      .addClass('active');
    this.setSelectRoi(id)
  }

  changeTchek(how: string) {
    console.log(how, this.listTchek)
    this.cpt = -1;
    let index = -1;
    if (this.listTchek.length === 0)
      this._toastService.toastOpen(undefined, 
        this.i18n({
          id: 'emptyList',
          value: "listTchek vide.",
          description: "listTchek vide.",
          meaning: "annotation"
        }) , "error");
    else {
      index = this.listTchek.findIndex(d => { return d.id === this.tchekId });
      if (index < 0)
        this._toastService.toastOpen(undefined,
          this.i18n({
            id: 'errorList',
            value: "listTchek error.",
            description: "listTchek error.",
            meaning: "annotation"
          }) , "error");
      else {
        this.selectedRoiFc = []
        this.classificationSelectedRoi = undefined
        this.selectedRoi = undefined;
        this.previous = this.i18n({
          id: 'previous',
          value: 'Tchek Précédent',
          description: 'Tchek Précédent',
          meaning: "annotation"
        })
        this.next = this.i18n({
          id: 'next',
          value: 'Suivant',
          description: 'Suivant',
          meaning: "annotation"
        })
        if (how === "next") {
          // console.log("go to", `/player/${this.listTchek[index + 1].id}/1/0`);
          this._router
            .navigate(['redirectPlayer', this.listTchek[index + 1].id])
            .then(success => !success && console.log('Navigation failed'))
            .catch(e => console.error(e));
        } else {
          this._router
            .navigate(['redirectPlayer', this.listTchek[index - 1].id])
            .then(success => !success && console.log('Navigation failed'))
            .catch(e => console.error(e));
        }
      }
    }
  }


  arrowMoveClassification(v: number) {
    console.log('arrowMoveClassification')
    this.cpt = this.cpt + v;
    if (this.cpt + 1 > this.damageList.length) {
      this.changeTchek("next");
    } else if (this.cpt < 0) {
      this.changeTchek("previous");
    } else {
      this.damageSelected.listRoi = []
      this._classificationService.newAnnotation(this.damageSelected)
      this.setSelectDamage(this.damageList[this.cpt].id);
    }
  }

  async setSelectDamage(id) {

    let index = this.damageList.findIndex(d => { return d.id === id });
    if (index === -1) {
      //console.log("error index");
      return;
    }
    this._classificationService.setSelectedDamage(this.damageList[index])
    if (!this.classificationSelectedRoi)
      this._classificationService.setSelectedRoi(this.damageList[index].listRoi[0])
    this.cpt = index;
    if (index > 0)
      this.previous = this.i18n({
        id: 'previous',
        value: 'Précédent',
        description: 'Précédent',
        meaning: "annotation"
      })
    else
      this.previous = this.i18n({
        id: 'previousTchek',
        value: 'Tchek Précédent',
        description: 'Tchek Précédent',
        meaning: "annotation"
      })

    if ((index + 1) === this.damageList.length || this.damageList.length === 0)
      this.next = this.i18n({
        id: 'nextTchek',
        value: 'Tchek Suivant',
        description: 'Tchek Suivant',
        meaning: "annotation"
      })

    else
      this.next = this.i18n({
        id: 'next',
        value: 'Suivant',
        description: 'Suivant',
        meaning: "annotation"
      })

    this.damageSelectedFc = []

    let type = this._vehicledamage.transform(this.damageSelected.type).toString()
    this.damageSelectedFc[0] = type;
    if (this.listDamages.includes(type) === false) {
      this.typeExist = false
    } else {
      this.typeExist = true
    }
    console.log('type', this.damageSelectedFc[0], this.typeExist);

    let i = 0;
    this.listAnnotateOnAttributes = [];
    this.updateActiveAnnotationType();
    if (this.listDamagesAttributes[type]) {
      let tab = flatten(Object.entries(this.listDamagesAttributes[type]));
      while (tab[i]) {
        if (tab[i] !== 'Faux Positif') {
          let value: { key: string, value: string, attributes: string }[] = [];
          tab[i + 1].forEach(element => {
            value.push({ key: element, value: element, attributes: tab[i] });
          });
          this.listAnnotateOnAttributes.push({ name: tab[i], list: value, count: i + 1 });
        }
        let data;
        if (tab[i] === 'Taille')
          data = 'Niv' + (this.damageSelected.sev ? this.damageSelected.sev : '0')


        this.damageSelectedFc[i + 1] = {
          value: data,
          key: data, attribute: tab[i]
        }

        i += 2;
      }
    }
  }


  skip(damage: boolean, status?: classificationStatusRoi) {
    if (!this.damageSelected || !this.classificationSelectedRoi)
      return;
    this._classificationService.canSave = false

    if (damage) {
      this.damageSelected.toSync = true;
      this.damageSelected.skipClassification = true;
      this._damageService.save(this.damageSelected)
        .then(savedDamage => {
          if (savedDamage) {
            this._classificationService.newAnnotation(this.damageSelected)
            this._toastService.toastOpen();
          }
        });
    } else if (status) {
      this.classificationSelectedRoi.classificationStatus = status
      this.classificationSelectedRoi.toSync = true
      this._damageService.saveEditRoi(this.classificationSelectedRoi).then(savedRoi => {
        if (savedRoi) {
          this.loadAnnotations()
          this.damageSelected.listRoi.splice(this.damageSelected.listRoi.findIndex(r => { return r.id === this.classificationSelectedRoi.id }), 1)
          if (this.damageSelected.listRoi.length === 0) {
            this.damageSelected.toSync = true;
            this.damageSelected.skipClassification = true;
            this._damageService.save(this.damageSelected)
              .then(savedDamage => {
                if (savedDamage) {
                  this._toastService.toastOpen();
                }
              });
          }

          this._classificationService.newAnnotation(this.damageSelected)
        }
      })

    }
  }

  fp() {
    this.saveClassification(true)
  }

  saveClassification(fauxPositif?: boolean, status: classificationStatusRoi = this.classificationStatusRoi.classified, taille?: string) {
    if (!this.damageSelected || !this.classificationSelectedRoi)
      return;

    this._classificationService.canSave = false
    let i = 0;
    let label;
    let attributes: { name: string, value: string }[] = [];

    if (taille)
      taille = 'Niv' + taille;

    this.damageSelectedFc.forEach((e) => {
      if (i === 0) {
        if (e)
          label = e
      } else {
        if (fauxPositif && e.attribute === 'Faux Positif')
          attributes.push({ name: 'Faux Positif', value: 'Oui' })
        else if (taille && e.attribute === 'Taille')
          attributes.push({ name: 'Taille', value: taille })
        else
          attributes.push({ name: e.attribute, value: e.key })
      }
      i++;
    });

    if (this.DEBUG) {
      this._classificationService.newAnnotation(this.damageSelected)
      return
    }

    this._annotationService.createAnnotation(
      this._roiService.transformMaskToPoints(this.classificationSelectedRoi.mask),
      label,
      attributes,
      this.classificationSelectedRoi.picture,
      this.classificationSelectedRoi.folder,
      this.damageSelected.id,
      this.classificationSelectedRoi.id,
      undefined, undefined, parse.User.current());

    this.classificationSelectedRoi.classificationStatus = status
    this.classificationSelectedRoi.toSync = true
    if (this.damageSelected.listRoi.length === 1) {
      this.damageSelected.toSync = true;
      this.damageSelected.classification = true;
    }
    if (fauxPositif && this.classificationSelectedRoi.id === this.damageSelected.roiPtr.id) {
      this.damageSelected.toSync = true;
      this.damageSelected.classification = true;
      this.damageSelected.isDeleted = true;
    }
    this._damageService.saveEditRoi(this.classificationSelectedRoi).then(savedRoi => {
      if (savedRoi) {
        this.loadAnnotations()
        this.damageSelected.listRoi.splice(this.damageSelected.listRoi.findIndex(r => { return r.id === this.classificationSelectedRoi.id }), 1)
        if (this.damageSelected.listRoi.length === 0
          || (fauxPositif && this.classificationSelectedRoi.id === this.damageSelected.roiPtr.id)) {
          this._damageService.save(this.damageSelected)
            .then(savedDamage => {
              if (savedDamage) {
                this._toastService.toastOpen()
                this._classificationService.newAnnotation(this.damageSelected)
              }
            });
        } else {
          this._toastService.toastOpen()
          this._classificationService.newAnnotation(this.damageSelected)
        }
      }
    })
  }

  getAnnotateType(label: string): string {
    //  console.log(label)
    if (this.listPieces.includes(label)) {
      // console.log('annotate part')
      return 'part'
    } else {
      // console.log('annotate damage')
      return 'damage'
    }
  }


  getCurrentAnnotateList() {
    if (this.getAnnotateType(this.selectedRoi.type) === 'part')
      return this.listPieces
    else
      return this.listDamages
  }


  changeType(event) {
    this.damageSelectedFc = []
    this.damageSelectedFc[0] = event;
    if (this.listDamages.includes(this.damageSelectedFc[0]) === false) {
      this.typeExist = false
    } else {
      this.typeExist = true
    }
    console.log('type', this.damageSelectedFc[0], this.typeExist);
    let i = 0;
    this.listAnnotateOnAttributes = [];
    let listAttribute;
    if (this.getAnnotateType(this.damageSelectedFc[0]) === 'part')
      listAttribute = this.listPartsAttributes;
    else
      listAttribute = this.listDamagesAttributes;
    if (listAttribute[this.damageSelectedFc[0]]) {
      let tab = flatten(Object.entries(listAttribute[this.damageSelectedFc[0]]));
      while (tab[i]) {
        if (tab[i] !== 'Faux Positif') {
          let value: { key: string, value: string, attributes: string }[] = [];
          tab[i + 1].forEach(element => {
            value.push({ key: element, value: element, attributes: tab[i] });
          });


          this.listAnnotateOnAttributes.push({ name: tab[i], list: value, count: i + 1 });
        }
        let data;
        if (tab[i] === 'Taille')
          data = 'Niv' + (this.damageSelected.sev ? this.damageSelected.sev : '0')

        this.damageSelectedFc[i + 1] = {
          value: data,
          key: data, attribute: tab[i]
        }

        i += 2;
      }
    }
  }


  arrowMoveAnnotation(v: number) {
    this.cpt = this.cpt + v;
    if (this.cpt + 1 > this.autoRoisSearch.length) {
      this.changeTchek("next");
    } else if (this.cpt < 0) {
      this.changeTchek("previous");
    } else {
      this.setSelectRoi(this.autoRoisSearch[this.cpt].id);
      console.log('navigate 5');


      if (this.autoRoisSearch[this.cpt].get('imagePtr'))
        this._router.navigate(['/viewer', this.tchekId, this.autoRoisSearch[this.cpt].get('imagePtr').id]);
      else
        this._router.navigate(['/player/',
          this.tchekId,
          this.autoRoisSearch[this.cpt].get('folder'),
          this.toPicturePercent(this.autoRoisSearch[this.cpt].get('sequence'),
            this.autoRoisSearch[this.cpt].folderPtr.get('totalPictures'))]);
    }
  }

  async setSelectRoi(id) {
    let index = this.autoRoisSearch.findIndex(d => { return d.id === id });
    if (index === -1) {
      //console.log("error index");
      return;
    }
    this.cpt = index;
    this.selectedRoiFc = []

    this.selectedRoi = {
      count: index + 1, type: this.autoRoisSearch[index].get('label'),
      attributes: this.autoRoisSearch[index].get('attributes'),
      id: this.autoRoisSearch[index].id
    }
    this._annotationService.setSelectAnnotation(this.autoRoisSearch[index])

    this.selectedRoiFc[0] = this.selectedRoi.type ? this.selectedRoi.type : 'No Label'

    if (this.classificationIsActive)
      return;

    if (index > 0)
      this.previous = this.i18n({
        id: 'previous',
        value: 'Précédent',
        description: 'Précédent',
        meaning: "annotation"
      })

    else
      this.previous = this.i18n({
        id: 'previousTchek',
        value: 'Tchek Précédent',
        description: 'Tchek Précédent',
        meaning: "annotation"
      })
  
    if ((index + 1) === this.autoRoisSearch.length || this.autoRoisSearch.length === 0)
      this.next = this.i18n({
        id: 'nextTchek',
        value: 'Tchek Suivant',
        description: 'Tchek Suivant',
        meaning: "annotation"
      })
      
    else
      this.next = this.i18n({
        id: 'next',
        value: 'Suivant',
        description: 'Suivant',
        meaning: "annotation"
      })

    this.changeSelectedRoi(this.selectedRoi.type, true, true);
  }

  count(): number {
    if (!this.autoRoisSearch)
      return -1;
    let total = 0;
    if (this.autoRoisSearch.length > 0)
      total = this.autoRoisSearch.length;
    else
      total = this.autoRois.length;

    /* for (let cam in this.autoRois) {
      total += this.autoRois[cam].length;
    } */
    return total;
  }

  cameras(): Array<string> {
    if (!this.autoRoisSearch)
      return [];
    else
      return Object.keys(this.autoRoisSearch);
  }

  editListCheckbox(newList) {
    this.activeAnnotationType = newList;
    this.searchAnnotationType()
  }

  updateActiveAnnotationType() {
    this.activeAnnotationType = this._annotationService.activeAnnotationType;
    this.autoRois.forEach(e => {
      let name = e.get('label') ? e.get('label') : 'No label';
      let strAttributes = '';
      let attributes = e.get('attributes');
      if (attributes) {
        attributes.forEach(a => {
          strAttributes += ` ${a.name} : ${a.value}`;
        });
      }
      let index = true;
      this.activeAnnotationType.forEach(element => {
        if (element.value === (name + strAttributes))
          index = false;
      })

      if (index)
        this.activeAnnotationType.push({ display: name + strAttributes, value: name + strAttributes, checked: false });
    });
    let currentImage = new SearchTagCheckbox('Image', 'currentImage', false)
    this.activeAnnotationType.push(currentImage)
    this._annotationService.activeAnnotationType = this.activeAnnotationType;
  }

  searchAnnotationType() {
    console.log('slide', this.isSliding)
    let usefilters: boolean = false;
    this.autoRoisSearch = [];
    this.activeAnnotationType.forEach(e => {
      if (e.checked === true)
        usefilters = true;
    })
    if (usefilters)
      this.autoRois.forEach(e => {
        let name = e.get('label') ? e.get('label') : 'No label';
        let strAttributes = '';
        let attributes = e.get('attributes');
        if (attributes) {
          attributes.forEach(a => {
            strAttributes += ` ${a.name} : ${a.value}`;
          });
        }
        this.activeAnnotationType.forEach(list => {

          if (this.isSliding === false && list.value === 'currentImage' && list.checked === true
            && ((this.cameraName === e.get('folder')
              && this.pictureNumber && e.get('sequence')
              && parseInt(this.pictureNumber, 10) === e.get('sequence'))
              || (this.currentImage
                && e.get('sequence') === undefined
                && e.get('imagePtr').id === this.currentImage.id))) {
            this.autoRoisSearch.push(e)
          } else if ((name + strAttributes) === list.value && list.checked === true)
            this.autoRoisSearch.push(e)
        })

      });
    else
      this.autoRoisSearch = this.autoRois;

    if (this.autoRoisSearch !== undefined && this.autoRoisSearch.length === 0)
      this.next = this.i18n({
        id: 'nextTchek',
        value: 'Tchek Suivant',
        description: 'Tchek Suivant',
        meaning: "annotation"
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/element/annotation-drawer/annotation-drawer.component.ts